<template>
  <form
    class="form-patient-health-question"
    v-on:submit.prevent="submit"
  >
    <input-text
      class="form-patient-health-question__input"
      title="Вопрос"
      v-bind:maxlength="maxLengthQuestion"
      v-bind:rows="1"
      v-model="question"
      v-letter-capital
      v-bind:violations="nameInputErrors"
    />
    <input-select
      class="form-patient-health-question__input"
      option-title-key="name"
      option-value-key="value"
      title="Категория"
      v-bind:options="$options.groupsQuestion"
      v-model="groupId"
      v-bind:violations="groupIdInputErrors"
    />
    <div class="form-patient-health-question__input">
      <input-checkbox
        class="form-patient-health-question__input"
        v-model="isOpenQuestion"
        v-bind:title="'Вопрос с полем для ответа'"
        v-bind:violations="isOpenQuestionInputErrors"
      />
    </div>
    <button
      class="form-patient-health-question__button"
      type="submit">
      {{buttonTitle}}
    </button>
  </form>
</template>

<script>
import InputText from '@/components/InputText.vue';
import InputSelect from '@/components/InputSelect.vue';
import { PatientQuestion } from '@/storage/gateways/PatientHealthQuestionnaireGateway';
import InputCheckbox from '@/components/InputCheckbox.vue';

/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.inputErrors ? vm.inputErrors[cause] : []
);

/**
 * Отправить вопрос
 *
 * @type {string}
 */
const ON_SUBMIT_QUESTION = 'on-submit-question';

export default {
  name: 'FormPatientHealthQuestion',
  components: {
    InputCheckbox,
    InputSelect,
    InputText,
  },
  computed: {
    buttonTitle() {
      return this.id ? 'Изменить' : 'Сохранить';
    },
    /**
     * @description Ошибки длины
     * @returns {function}
     */
    nameInputErrors: resolveInputErrors('question-length'),
    groupIdInputErrors: resolveInputErrors('group-id'),
    isOpenQuestionInputErrors: resolveInputErrors('is_open_question'),
  },
  data() {
    return {
      id: this.patientQuestion.id,
      groupId: this.patientQuestion.groupId,
      question: this.patientQuestion.question,
      isOpenQuestion: this.patientQuestion.isOpenQuestion,
      /**
       * @description Максимальная длина вопроса.
       * @type {Number}
       */
      maxLengthQuestion: 254,
    };
  },
  methods: {
    /**
     * @description Отправить данные
     * @return {void}
     */
    submit() {
      const question = new PatientQuestion(
        this.id,
        this.groupId,
        this.question,
        this.isOpenQuestion,
      );
      this.$emit(ON_SUBMIT_QUESTION, question);
    },
  },
  props: {
    /**
     * @description Вопрос анкеты пациента.
     * @type PatientQuestion
     */
    patientQuestion: {
      type: PatientQuestion,
      required: false,
      default: () => new PatientQuestion(),
    },
    /**
     * @description Ограничения нарушений.
     * @type {any}
     */
    inputErrors: { type: Object, required: true },
  },
  /**
   * @description Группы для вопросов анкеты пациента
   * @type {Array}
   */
  groupsQuestion: [
    {
      name: 'Аллергические реакции',
      value: 'allergic_reactions',
    }, {
      name: 'Общие вопросы',
      value: 'common',
    }, {
      name: 'При прохождении стоматологического лечения в прошлом были:',
      value: 'dental_care',
    }, {
      name: 'Вопросы для женщин',
      value: 'for_females',
    },
  ],
};
</script>

<style scoped lang="scss">
@use "@/scss/buttons";

.form-patient-health-question {
  &__input {
   margin-top: 20px;
  }
  &__button {
    @include buttons.btn-blue(10rem, 3rem, 1rem);
    margin-top: 20px;
    margin-left: auto;
  }
}
</style>
